import {
  FETCH_SERIES,
  FETCH_SERIES_SUCCESS,
  FETCH_SERIES_FAIL,
  NEXT_QUESTION,
  SET_CURRENT_SERIE,
  FETCH_SERIE_RESULT_SUCCESS
} from 'config/types';

import { find, findIndex } from 'lodash';

const INITIAL_STATE = {
  isLoading: false,
  series: [],
  nextQuestion: {},
  currentSerie: undefined,
  result: undefined
};

export default function series(state=INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_SERIES:
      return {...state, isLoading: true};
    case FETCH_SERIES_SUCCESS: {
      const nextQuestion = {}
      action.payload.map((serie) => {
        nextQuestion[serie.id] = serie.next_question
      });
      return {...state, series: action.payload, nextQuestion: nextQuestion, isLoading: false};
    }
    case FETCH_SERIES_FAIL:
      return {...state, isLoading: false};
    case SET_CURRENT_SERIE:
      return {...state, currentSerie: action.payload, result: undefined}
    case NEXT_QUESTION:
      const currentSerie = find(state.series, s => s.id === state.currentSerie);
      const currentIndex = findIndex(currentSerie.questions, q => q === action.payload);
      const nextQuestion = currentSerie.questions.length > currentIndex + 1 ? currentSerie.questions[currentIndex + 1] : -1
      return {...state, nextQuestion: {...state.nextQuestion, [currentSerie.id]: nextQuestion}}
    case FETCH_SERIE_RESULT_SUCCESS:
      return {...state, result: action.payload}
    default:
      return state;
  }
}
